import { Tabs } from "antd";
import K from "utilities/constants";
import UdfField from "./usdField/udfField";
import { getDefaultJobFields } from "../../../../config/jobFields";
import { getDefaultCandidateFields } from "../../../../config/candidateFields";
import { CandidateFieldRenderer } from "../../../../common/components/candidateFieldRenderer/candidateFieldRenderer";
import {
  candidateFieldContext,
  getUdfDefaultValue,
  jobFieldContext,
} from "./fieldsContext";
import { JobFieldRenderer } from "../../../../common/components/jobFieldRenderer/jobFieldRenderer";

export default function UserDefinedFields() {
  const items = [
    {
      key: "1",
      label: "Client",
      children: (
        <UdfField
          entityId={K.UDF.Entities.Client.id}
          tableConfigKey={`${K.AgGridTable.Keys.UserDefinedsVisibleColumn}_Client`}
        />
      ),
    },
    {
      key: "2",
      label: "Job",
      children: (
        <UdfField
          entityId={K.UDF.Entities.JobSource.id}
          tableConfigKey={`${K.AgGridTable.Keys.UserDefinedsVisibleColumn}_Job`}
          isLayoutEditable
          layoutConfigKey="job_form"
          layoutDisplayName="Job Form"
          getDefaultFieldLayout={getDefaultJobFields}
          previewFieldRenderer={(field, props) => (
            <div style={{ minHeight: 84 }}>
              <JobFieldRenderer
                field={field}
                context={{ ...jobFieldContext, ...props }}
              />
            </div>
          )}
        />
      ),
    },
    {
      key: "3",
      label: "Candidate",
      children: (
        <UdfField
          entityId={K.UDF.Entities.Candidate.id}
          tableConfigKey={`${K.AgGridTable.Keys.UserDefinedsVisibleColumn}_Candidate`}
          isLayoutEditable={false}
          layoutConfigKey="candidate_job_view"
          layoutDisplayName="Candidate Job View"
          getDefaultFieldLayout={getDefaultCandidateFields}
          previewFieldRenderer={(field, props) => (
            <CandidateFieldRenderer
              field={field}
              context={{ ...candidateFieldContext, ...props }}
              getUdfValue={(f) => getUdfDefaultValue(f.udfData.fieldTypeId)}
            />
          )}
        />
      ),
    },
  ];

  return (
    <Tabs className="billing-rule-tab" defaultActiveKey="1" items={items} />
  );
}
